import { TTagField, UTILS } from '@aksia/infrastructure';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'tagField',
  standalone: true,
})
export class TagFieldPipe implements PipeTransform {
  transform(value: string, tagFields: Array<TTagField>): string {
    let fields = value.split('.');
    let tag = '';
    let fieldIndex = '';

    fields?.forEach((field, index) => {
      field = field.replace(/\[(\d+)\]/g, (g0, g1) => {
        fieldIndex = `#${+g1 + 1}`;
        return g0?.split('[')[0] || '';
      });
      let tagField = tagFields.find(
        (tagField) => tagField.field === UTILS.STRING.toCamelCase(field, true),
      )?.tag;

      if (tagField) {
        tag += `${tag?.length > 0 ? ' - ' : ''}${tagField}${fieldIndex ? ` ${fieldIndex}` : ''}`;
      } else {
        console.warn(
          `TagFieldPipe: No tag found for field "${field}" in tagFields. Please check your configuration.`,
        );
      }
      fieldIndex = '';
    });
    return tag;
  }
}
